
import Cell from 'vux/src/components/cell/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'

import { getProvince, getCity, getCounty } from '@/api/sys.js'
export default {
directives: {
TransferDom
},
name: 'address-picker',
components: { Cell, Popup },
props: {
title: String,
placeholder: String,
value: Array,
column: {
default: 3
},
valueTextAlign: String
},
data () {
return {
show: false,
tab: ['请选择'],
tabactive: 0,
addresslist: ['', '', ''],
currName: this.placeholder,
first: true
}
},
mounted () {
this.init()
},
methods: {
init () {

this.getData('getProvince', '', data => {
this.addresslist[0] = data
if (this.value.length > 0 && this.first) {
this.first = false
data.forEach(element => {
if (element.value == this.value[0]) {
this.tab[0] = element.name
this.currName = element.name
}
})

if (this.value[0] != '' && this.column >= 2) {
this.getData('getCity', this.value[0], data2 => {
this.addresslist[1] = data2
data2.forEach(element2 => {
if (element2.value == this.value[1]) {
this.tab[1] = element2.name
this.currName += element2.name
}
})
if (this.value[1] != '' && this.column >= 3) {
this.getData('getCounty', this.value[1], data3 => {
this.addresslist[2] = data3
data3.forEach(element3 => {
if (element3.value == this.value[2]) {
this.tab[2] = element3.name
this.currName += element3.name
}
})
})
}
})
}
}
})
},
click (index) {
this.tabactive = index
},
check (name, value) {
let type = ''
if (this.tabactive == 0) type = 'getCity'
if (this.tabactive == 1) type = 'getCounty'

this.tab[this.tabactive] = name
this.value.splice(this.tabactive, this.column - this.tabactive)
this.value.push(value)

if (this.tabactive == this.column - 1) {
this.getValue()
} else {
this.getData(type, value, data => {
if (data.length > 0) {
this.tabactive++
this.$set(this.tab, this.tabactive, '请选择')
this.$set(this.addresslist, this.tabactive, data)
} else {
this.$delete(this.tab, this.tabactive + 1)
this.$delete(this.addresslist, this.tabactive + 1)
this.getValue()
}
})
}
},
getValue () {
this.show = false
this.currName = ''
this.tab.forEach(el => {
this.currName += el
})
this.$emit('input', this.value)
},
getData (type, id, fn) {
if (type === 'getProvince') {
getProvince({ plistvalue: id }).then(data => {
let list = []
data.obj.forEach(element => {
if (element.key != '') {
list.push({
name: element.value,
value: element.key
})
}
})
if (fn) fn(list)
})
} else if (type === 'getCity') {
getCity({ plistvalue: id }).then(data => {
let list = []
data.obj.forEach(element => {
if (element.key != '') {
list.push({
name: element.value,
value: element.key
})
}
})
if (fn) fn(list)
})
} else {
getCounty({ plistvalue: id }).then(data => {
let list = []
data.obj.forEach(element => {
if (element.key != '') {
list.push({
name: element.value,
value: element.key
})
}
})
if (fn) fn(list)
})
}
}
},
watch: {
value: {
handler () {
this.init()
},
deep: true
},
addresslist (newVal, oldVal) {
}
}
}
